// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { IoIosArrowForward } from "react-icons/io";
// import { FaFilter } from "react-icons/fa";
// import { TbReload, TbArrowsSort } from "react-icons/tb";
// import { MdOutlineAdd } from "react-icons/md";
// import Addgroup from './addgroup';

// const API_URL = process.env.REACT_APP_API_BASE;

// const COUNTRY_CODES = [
//     { code: '+91',  label: '🇮🇳 +91 India' },
//     { code: '+1',   label: '🇺🇸 +1 USA' },
//     { code: '+44',  label: '🇬🇧 +44 UK' },
//     { code: '+971', label: '🇦🇪 +971 UAE' },
//     { code: '+61',  label: '🇦🇺 +61 Australia' },
//     { code: '+49',  label: '🇩🇪 +49 Germany' },
//     { code: '+33',  label: '🇫🇷 +33 France' },
//     { code: '+81',  label: '🇯🇵 +81 Japan' },
//     { code: '+86',  label: '🇨🇳 +86 China' },
//     { code: '+55',  label: '🇧🇷 +55 Brazil' },
//     { code: '+27',  label: '🇿🇦 +27 South Africa' },
//     { code: '+60',  label: '🇲🇾 +60 Malaysia' },
//     { code: '+65',  label: '🇸🇬 +65 Singapore' },
//     { code: '+92',  label: '🇵🇰 +92 Pakistan' },
//     { code: '+880', label: '🇧🇩 +880 Bangladesh' },
// ];

// const EMPTY_FORM = { country_code: '+91', phone: '', name: '', email: '' };

// function ManageContacts() {
//     const { groupId } = useParams();   // route: /groups/:groupId/contacts
//     const navigate    = useNavigate();

//     const [group,    setGroup]    = useState(null);
//     const [contacts, setContacts] = useState([]);
//     const [filtered, setFiltered] = useState([]);
//     const [loading,  setLoading]  = useState(false);

//     // Filter
//     const [showFilter,   setShowFilter]   = useState(false);
//     const [filterPhone,  setFilterPhone]  = useState('');
//     const [filterName,   setFilterName]   = useState('');
//     const [filterEmail,  setFilterEmail]  = useState('');

//     // Modal
//     const [modalOpen,      setModalOpen]      = useState(false);
//     const [editingContact, setEditingContact] = useState(null);
//     const [form,           setForm]           = useState(EMPTY_FORM);
//     const [saving,         setSaving]         = useState(false);

//     // ── GET /groups/:groupId  →  { ...group, contacts: [] } ───────────────────
//     async function fetchContacts() {
//         if (!groupId) return;
//         setLoading(true);
//         try {
//             const res  = await fetch(`${API_URL}/auth/groups/${groupId}`);
//             const data = await res.json();
//             setGroup(data);
//             const list = data.contacts || [];
//             setContacts(list);
//             setFiltered(list);
//         } catch (err) {
//             console.error('Error fetching contacts:', err);
//         } finally {
//             setLoading(false);
//         }
//     }

//     useEffect(() => { fetchContacts(); }, [groupId]);

//     // ── Client-side filter ─────────────────────────────────────────────────────
//     function applyFilter() {
//         const result = contacts.filter(c => {
//             const okPhone = filterPhone ? (c.phone  || '').includes(filterPhone)                              : true;
//             const okName  = filterName  ? (c.name   || '').toLowerCase().includes(filterName.toLowerCase())  : true;
//             const okEmail = filterEmail ? (c.email  || '').toLowerCase().includes(filterEmail.toLowerCase()) : true;
//             return okPhone && okName && okEmail;
//         });
//         setFiltered(result);
//     }

//     function clearFilter() {
//         setFilterPhone(''); setFilterName(''); setFilterEmail('');
//         setFiltered(contacts);
//     }

//     // ── Modal helpers ──────────────────────────────────────────────────────────
//     function openCreateModal() {
//         setEditingContact(null);
//         setForm(EMPTY_FORM);
//         setModalOpen(true);
//     }

//     function openEditModal(contact) {
//         setEditingContact(contact);
//         setForm({
//             country_code: contact.country_code || '+91',
//             phone:        contact.phone  || '',
//             name:         contact.name   || '',
//             email:        contact.email  || '',
//         });
//         setModalOpen(true);
//     }

//     function closeModal() {
//         setModalOpen(false);
//         setEditingContact(null);
//         setForm(EMPTY_FORM);
//     }

//     function handleChange(field, value) {
//         setForm(prev => ({ ...prev, [field]: value }));
//     }

//     // ── Save ───────────────────────────────────────────────────────────────────
//     // CREATE:  POST /auth/contacts  →  { contact_id }
//     //          POST /auth/groups/:groupId/contacts  { contact_ids: [id] }
//     // UPDATE:  PUT  /auth/contacts/:contactId
//     async function saveContact() {
//         if (!form.phone.trim()) { alert('Phone number is required'); return; }

//         setSaving(true);
//         try {
//             if (editingContact) {
//                 // UPDATE  →  PUT /auth/contacts/:contactId
//                 const res = await fetch(`${API_URL}/auth/contacts/${editingContact.id}`, {
//                     method:  'PUT',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify({
//                         phone:        form.phone.trim(),
//                         name:         form.name.trim()  || null,
//                         email:        form.email.trim() || null,
//                         country_code: form.country_code,
//                     }),
//                 });
//                 if (!res.ok) throw new Error(await res.text());

//             } else {
//                 // 1. CREATE contact  →  POST /auth/contacts
//                 const user_id = localStorage.getItem('user_id') || 1;
//                 const createRes = await fetch(`${API_URL}/auth/contacts`, {
//                     method:  'POST',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify({
//                         user_id,
//                         phone:        form.phone.trim(),
//                         name:         form.name.trim()  || null,
//                         email:        form.email.trim() || null,
//                         country_code: form.country_code,
//                     }),
//                 });
//                 if (!createRes.ok) throw new Error(await createRes.text());
//                 const { contact_id } = await createRes.json();
//                 if (!contact_id) throw new Error('No contact_id returned');

//                 // 2. Link to group  →  POST /auth/groups/:groupId/contacts
//                 const linkRes = await fetch(`${API_URL}/auth/groups/${groupId}/contacts`, {
//                     method:  'POST',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify({ contact_ids: [contact_id] }),
//                 });
//                 if (!linkRes.ok) throw new Error(await linkRes.text());
//             }

//             closeModal();
//             await fetchContacts();
//         } catch (err) {
//             console.error('Error saving contact:', err);
//             alert('Failed to save contact. Please try again.');
//         } finally {
//             setSaving(false);
//         }
//     }

//     // ── Delete  →  DELETE /auth/groups/:groupId/contacts/:contactId ───────────
//     async function deleteContact(contactId) {
//         if (!window.confirm('Remove this contact from the group?')) return;
//         try {
//             await fetch(`${API_URL}/auth/groups/${groupId}/contacts/${contactId}`, {
//                 method: 'DELETE',
//             });
//             await fetchContacts();
//         } catch (err) {
//             console.error('Error removing contact:', err);
//         }
//     }

//     // ── Export  →  GET /auth/export/csv?groupId=… ─────────────────────────────
//     function exportCsv() {
//         window.location.href = `${API_URL}/auth/export/csv?groupId=${groupId}`;
//     }

//     return (
//         <>
//             <div className='dark:bg-[#121519] bg-[#fff] min-h-screen w-[100%] px-4'>

//                 {/* ── Header ── */}
//                 <div className='border-b-[1px] border-[#cfcdcd] pb-1 flex justify-between items-start'>
//                     <div>
//                         <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>
//                             Manage Contacts
//                             {group && (
//                                 <span className='ml-2 text-[14px] font-normal text-[#316bb0]'>
//                                     — {group.group_name}
//                                 </span>
//                             )}
//                         </h1>
//                         <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center'>
//                             <span>Home</span>
//                             <IoIosArrowForward />
//                             <span
//                                 onClick={() => navigate('/groups')}
//                                 className='hover:text-[#316bb0] cursor-pointer'
//                             >
//                                 Group List
//                             </span>
//                             <IoIosArrowForward />
//                             <span>Manage Contacts</span>
//                         </div>
//                     </div>
//                     <div className='flex gap-2 mt-1'>
//                         <button
//                             onClick={exportCsv}
//                             className='hover:bg-[#37715d] border-[1px] border-[#37715d] flex items-center text-[11px] hover:text-[#fff] text-[#37715d] font-bold p-2 gap-1 rounded-[5px]'
//                         >
//                             ⬇️ Export CSV
//                         </button>
//                         <button
//                             onClick={() => navigate('/groups')}
//                             className='hover:bg-[#576071] border-[1px] border-[#576071] flex items-center text-[11px] hover:text-[#fff] text-[#576071] font-bold p-2 gap-1 rounded-[5px]'
//                         >
//                             ← Back to Groups
//                         </button>
//                     </div>
//                 </div>

//                 {/* ── Add Contact button ── */}
//                 <button
//                     onClick={openCreateModal}
//                     className='hover:bg-[#316bb0] border-[1px] border-[#316bb0] flex items-center text-[11px] hover:text-[#fff] text-[#316bb0] font-bold p-2 gap-1 rounded-[5px] mt-4'
//                 >
//                     <MdOutlineAdd className='text-[14px]' />
//                     Add Contact
//                 </button>

//                 {/* ── Filter bar ── */}
//                 <div
//                     className='w-[100%] flex justify-between px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4 cursor-pointer'
//                     onClick={() => setShowFilter(v => !v)}
//                 >
//                     <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff]'>
//                         Filter Records
//                     </div>
//                     <span className='text-[#576071] dark:text-[#fff]'>
//                         {showFilter ? '▼' : '▲'}
//                     </span>
//                 </div>

//                 {showFilter && (
//                     <div
//                         className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519]'
//                         onClick={e => e.stopPropagation()}
//                     >
//                         <div className='w-[100%] flex flex-wrap gap-4'>
//                             {[
//                                 { label: 'Phone Number', value: filterPhone, set: setFilterPhone, type: 'text',  ph: 'Search phone...' },
//                                 { label: 'Name',         value: filterName,  set: setFilterName,  type: 'text',  ph: 'Search name...' },
//                                 { label: 'Email',        value: filterEmail, set: setFilterEmail, type: 'email', ph: 'Search email...' },
//                             ].map(f => (
//                                 <div key={f.label} className='w-full sm:w-[30%] flex flex-col gap-1'>
//                                     <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>{f.label}</label>
//                                     <input
//                                         value={f.value}
//                                         onChange={e => f.set(e.target.value)}
//                                         onKeyDown={e => e.key === 'Enter' && applyFilter()}
//                                         className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                         type={f.type}
//                                         placeholder={f.ph}
//                                     />
//                                 </div>
//                             ))}
//                             <div className='w-full sm:w-[auto] flex items-center gap-1 mt-4'>
//                                 <button
//                                     onClick={applyFilter}
//                                     className='flex items-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff]'
//                                 >
//                                     <FaFilter /> <span className='text-[12px] font-bold'>Filter</span>
//                                 </button>
//                                 <button
//                                     onClick={clearFilter}
//                                     className='flex items-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff]'
//                                 >
//                                     <TbReload /> <span className='text-[12px] font-bold'>Clear</span>
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 {/* ── Table ── */}
//                 <table className="w-full overflow-hidden border-[1px] border-[#dee2e6]">
//                     <thead>
//                         <tr>
//                             {['#', 'Phone Number', 'Name', 'Email', 'Country Code', 'Actions'].map((h, i) => (
//                                 <th key={h} className="p-2 border-[1px] border-[#dee2e6] text-left">
//                                     <div className="flex justify-between items-center gap-2">
//                                         <span className='text-[11px] text-[#576071] dark:text-[#fff]'>{h}</span>
//                                         {i > 0 && i < 5 && (
//                                             <button type="button" className="text-gray-400 hover:text-black">
//                                                 <TbArrowsSort />
//                                             </button>
//                                         )}
//                                     </div>
//                                 </th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {loading ? (
//                             <tr>
//                                 <td colSpan={6} className="p-4 text-center text-[12px] text-gray-400">Loading...</td>
//                             </tr>
//                         ) : filtered.length === 0 ? (
//                             <tr className="bg-[#f6f9fc] dark:bg-[#121519]">
//                                 <td colSpan={6} className="p-3 text-center text-[11px] text-gray-500">No contacts found</td>
//                             </tr>
//                         ) : (
//                             filtered.map((c, idx) => (
//                                 <tr key={c.id} className="text-[12px] border-b hover:bg-[#f7fafc] dark:hover:bg-[#1a1f26]">
//                                     <td className="p-2 text-gray-400">{idx + 1}</td>
//                                     <td className="p-2 font-medium">
//                                         {c.country_code && <span className='text-gray-400 mr-1'>{c.country_code}</span>}
//                                         {c.phone}
//                                     </td>
//                                     <td className="p-2">{c.name  || <span className='text-gray-300'>—</span>}</td>
//                                     <td className="p-2">{c.email || <span className='text-gray-300'>—</span>}</td>
//                                     <td className="p-2">
//                                         {c.country_code
//                                             ? <span className='bg-[#ebf4ff] text-[#316bb0] rounded px-2 py-0.5 text-[10px] font-bold'>{c.country_code}</span>
//                                             : <span className='text-gray-300'>—</span>
//                                         }
//                                     </td>
//                                     <td className="p-2">
//                                         <div className='flex gap-2'>
//                                             <button
//                                                 onClick={() => openEditModal(c)}
//                                                 title="Edit"
//                                                 className="border px-2 py-1 rounded text-blue-500 hover:bg-blue-50 text-[13px]"
//                                             >✏️</button>
//                                             <button
//                                                 onClick={() => deleteContact(c.id)}
//                                                 title="Remove from group"
//                                                 className="border px-2 py-1 rounded text-red-500 hover:bg-red-50 text-[13px]"
//                                             >🗑️</button>
//                                         </div>
//                                     </td>
//                                 </tr>
//                             ))
//                         )}
//                     </tbody>
//                 </table>

//                 <p className='text-[11px] text-[#3f7fc8] mt-2'>
//                     Showing 1 to {filtered.length} of {contacts.length} records
//                 </p>
//             </div>

//             {/* ── Add / Edit Contact Modal ── */}
//             <Addgroup
//                 isOpen={modalOpen}
//                 onClose={closeModal}
//                 heading={editingContact ? 'Edit Contact' : 'Add Contact'}
//             >
//                 <div className='py-2 border-y-[1px] border-[#8b8a8a67] my-2 w-[100%]'>
//                     <div className='flex flex-col gap-3'>

//                         {/* Country Code + Phone */}
//                         <div className='flex gap-2'>
//                             <div className='flex flex-col gap-1' style={{ minWidth: '140px' }}>
//                                 <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>
//                                     Country Code <span className='text-red-500'>*</span>
//                                 </label>
//                                 <select
//                                     value={form.country_code}
//                                     onChange={e => handleChange('country_code', e.target.value)}
//                                     className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                 >
//                                     {COUNTRY_CODES.map(c => (
//                                         <option key={c.code} value={c.code}>{c.label}</option>
//                                     ))}
//                                 </select>
//                             </div>
//                             <div className='flex flex-col gap-1 flex-1'>
//                                 <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>
//                                     Phone Number <span className='text-red-500'>*</span>
//                                 </label>
//                                 <input
//                                     value={form.phone}
//                                     onChange={e => handleChange('phone', e.target.value)}
//                                     className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                     type="tel"
//                                     placeholder='Enter mobile number'
//                                 />
//                                 <span className='text-[10px] text-gray-400'>Required for WABA messaging</span>
//                             </div>
//                         </div>

//                         {/* Name */}
//                         <div className='flex flex-col gap-1'>
//                             <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>
//                                 Name <span className='text-gray-400 font-normal'>(optional)</span>
//                             </label>
//                             <input
//                                 value={form.name}
//                                 onChange={e => handleChange('name', e.target.value)}
//                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                 type="text"
//                                 placeholder='Contact name'
//                             />
//                         </div>

//                         {/* Email */}
//                         <div className='flex flex-col gap-1'>
//                             <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>
//                                 Email <span className='text-gray-400 font-normal'>(optional)</span>
//                             </label>
//                             <input
//                                 value={form.email}
//                                 onChange={e => handleChange('email', e.target.value)}
//                                 className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
//                                 type="email"
//                                 placeholder='email@example.com'
//                             />
//                         </div>
//                     </div>
//                 </div>

//                 <div className='w-[100%] flex justify-end gap-1'>
//                     <button
//                         onClick={saveContact}
//                         disabled={saving}
//                         className='p-2 bg-[#00816a] rounded-md text-[12px] font-semibold text-[#fff] disabled:opacity-60'
//                     >
//                         {saving ? 'Saving...' : 'Save'}
//                     </button>
//                     <button
//                         onClick={closeModal}
//                         className='p-2 bg-[#d3dde6] rounded-md text-[12px] font-semibold text-[#555555]'
//                     >
//                         Close
//                     </button>
//                 </div>
//             </Addgroup>
//         </>
//     );
// }

// export default ManageContacts;

import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";
import { FaFilter } from "react-icons/fa";
import { TbReload, TbArrowsSort } from "react-icons/tb";
import { MdOutlineAdd } from "react-icons/md";
import * as XLSX from 'xlsx';
import Addgroup from './addgroup';

const API_URL = process.env.REACT_APP_API_BASE;

const COUNTRY_CODES = [
    { code: '+91',  label: '🇮🇳 +91 India' },
    { code: '+1',   label: '🇺🇸 +1 USA' },
    { code: '+44',  label: '🇬🇧 +44 UK' },
    { code: '+971', label: '🇦🇪 +971 UAE' },
    { code: '+61',  label: '🇦🇺 +61 Australia' },
    { code: '+49',  label: '🇩🇪 +49 Germany' },
    { code: '+33',  label: '🇫🇷 +33 France' },
    { code: '+81',  label: '🇯🇵 +81 Japan' },
    { code: '+86',  label: '🇨🇳 +86 China' },
    { code: '+55',  label: '🇧🇷 +55 Brazil' },
    { code: '+27',  label: '🇿🇦 +27 South Africa' },
    { code: '+60',  label: '🇲🇾 +60 Malaysia' },
    { code: '+65',  label: '🇸🇬 +65 Singapore' },
    { code: '+92',  label: '🇵🇰 +92 Pakistan' },
    { code: '+880', label: '🇧🇩 +880 Bangladesh' },
];

const EMPTY_FORM = { country_code: '+91', phone: '', name: '', email: '' };

// ─── tiny helpers ────────────────────────────────────────────────────────────
function parseCSV(text) {
    const lines = text.trim().split(/\r?\n/);
    if (!lines.length) return { headers: [], rows: [] };
    const headers = lines[0].split(',').map(h => h.replace(/^"|"$/g, '').trim());
    const rows = lines.slice(1).map(line =>
        line.split(',').map(c => c.replace(/^"|"$/g, '').trim())
    );
    return { headers, rows };
}

function parseTXT(text) {
    // tab-separated or comma-separated plain text
    const lines = text.trim().split(/\r?\n/);
    const sep = lines[0].includes('\t') ? '\t' : ',';
    const headers = lines[0].split(sep).map(h => h.trim());
    const rows = lines.slice(1).map(l => l.split(sep).map(c => c.trim()));
    return { headers, rows };
}

function parseXLSX(buffer) {
    const wb = XLSX.read(buffer, { type: 'array' });
    const ws = wb.Sheets[wb.SheetNames[0]];
    const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
    if (!data.length) return { headers: [], rows: [] };
    return {
        headers: (data[0] || []).map(String),
        rows: data.slice(1).map(r => r.map(String)),
    };
}

// ─────────────────────────────────────────────────────────────────────────────
function ManageContacts() {
    const { groupId } = useParams();
    const navigate    = useNavigate();

    const [group,    setGroup]    = useState(null);
    const [contacts, setContacts] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [loading,  setLoading]  = useState(false);

    // Filter
    const [showFilter,  setShowFilter]  = useState(false);
    const [filterPhone, setFilterPhone] = useState('');
    const [filterName,  setFilterName]  = useState('');
    const [filterEmail, setFilterEmail] = useState('');

    // Add/Edit modal
    const [modalOpen,      setModalOpen]      = useState(false);
    const [editingContact, setEditingContact] = useState(null);
    const [form,           setForm]           = useState(EMPTY_FORM);
    const [saving,         setSaving]         = useState(false);

    // Import state
    const [importModalOpen,  setImportModalOpen]  = useState(false);
    const [importFile,       setImportFile]       = useState(null);        // File object
    const [importFileName,   setImportFileName]   = useState('');
    const [importHeaders,    setImportHeaders]    = useState([]);          // column names from file
    const [importRows,       setImportRows]       = useState([]);          // raw data rows
    const [mappingOpen,      setMappingOpen]      = useState(false);       // mapping modal
    const [mapPhone,         setMapPhone]         = useState('');
    const [mapName,          setMapName]          = useState('');
    const [mapEmail,         setMapEmail]         = useState('');
    const [mapCountryCode,   setMapCountryCode]   = useState('');
    const [defaultCC,        setDefaultCC]        = useState('+91');
    const [importing,        setImporting]        = useState(false);
    const [importResult,     setImportResult]     = useState(null);        // { success, failed }
    const fileInputRef = useRef(null);

    // ── fetch ─────────────────────────────────────────────────────────────────
    async function fetchContacts() {
        if (!groupId) return;
        setLoading(true);
        try {
            const res  = await fetch(`${API_URL}/auth/groups/${groupId}`);
            const data = await res.json();
            setGroup(data);
            const list = data.contacts || [];
            setContacts(list);
            setFiltered(list);
        } catch (err) {
            console.error('Error fetching contacts:', err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => { fetchContacts(); }, [groupId]);

    // ── filter ────────────────────────────────────────────────────────────────
    function applyFilter() {
        setFiltered(contacts.filter(c => {
            const okPhone = filterPhone ? (c.phone  || '').includes(filterPhone) : true;
            const okName  = filterName  ? (c.name   || '').toLowerCase().includes(filterName.toLowerCase()) : true;
            const okEmail = filterEmail ? (c.email  || '').toLowerCase().includes(filterEmail.toLowerCase()) : true;
            return okPhone && okName && okEmail;
        }));
    }
    function clearFilter() {
        setFilterPhone(''); setFilterName(''); setFilterEmail('');
        setFiltered(contacts);
    }

    // ── add/edit modal ────────────────────────────────────────────────────────
    function openCreateModal() { setEditingContact(null); setForm(EMPTY_FORM); setModalOpen(true); }
    function openEditModal(c)  { setEditingContact(c); setForm({ country_code: c.country_code || '+91', phone: c.phone || '', name: c.name || '', email: c.email || '' }); setModalOpen(true); }
    function closeModal()      { setModalOpen(false); setEditingContact(null); setForm(EMPTY_FORM); }
    function handleChange(f, v){ setForm(p => ({ ...p, [f]: v })); }

    async function saveContact() {
        if (!form.phone.trim()) { alert('Phone number is required'); return; }
        setSaving(true);
        try {
            if (editingContact) {
                const res = await fetch(`${API_URL}/auth/contacts/${editingContact.id}`, {
                    method: 'PUT', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ phone: form.phone.trim(), name: form.name.trim() || null, email: form.email.trim() || null, country_code: form.country_code }),
                });
                if (!res.ok) throw new Error(await res.text());
            } else {
                const user_id = localStorage.getItem('user_id') || 1;
                const cr = await fetch(`${API_URL}/auth/contacts`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ user_id, phone: form.phone.trim(), name: form.name.trim() || null, email: form.email.trim() || null, country_code: form.country_code }),
                });
                if (!cr.ok) throw new Error(await cr.text());
                const { contact_id } = await cr.json();
                const lr = await fetch(`${API_URL}/auth/groups/${groupId}/contacts`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ contact_ids: [contact_id] }),
                });
                if (!lr.ok) throw new Error(await lr.text());
            }
            closeModal();
            await fetchContacts();
        } catch (err) {
            console.error(err);
            alert('Failed to save contact.');
        } finally {
            setSaving(false);
        }
    }

    async function deleteContact(contactId) {
        if (!window.confirm('Remove this contact from the group?')) return;
        await fetch(`${API_URL}/auth/groups/${groupId}/contacts/${contactId}`, { method: 'DELETE' });
        await fetchContacts();
    }

    function exportCsv() {
        window.location.href = `${API_URL}/auth/export/csv?groupId=${groupId}`;
    }

    // ── IMPORT: file selection & parsing ─────────────────────────────────────
    function openImportModal() {
        setImportFile(null); setImportFileName(''); setImportHeaders([]);
        setImportRows([]); setMappingOpen(false); setImportResult(null);
        setMapPhone(''); setMapName(''); setMapEmail(''); setMapCountryCode('');
        setImportModalOpen(true);
    }

    async function handleFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;
        setImportFile(file);
        setImportFileName(file.name);
        setImportResult(null);

        const ext = file.name.split('.').pop().toLowerCase();
        try {
            if (ext === 'csv') {
                const text = await file.text();
                const { headers, rows } = parseCSV(text);
                setImportHeaders(headers); setImportRows(rows);
            } else if (ext === 'txt') {
                const text = await file.text();
                const { headers, rows } = parseTXT(text);
                setImportHeaders(headers); setImportRows(rows);
            } else if (ext === 'xlsx' || ext === 'xls') {
                const buf = await file.arrayBuffer();
                const { headers, rows } = parseXLSX(buf);
                setImportHeaders(headers); setImportRows(rows);
            } else {
                alert('Unsupported file type. Use .csv, .xlsx, .xls, or .txt');
                setImportFile(null); setImportFileName('');
            }
        } catch (err) {
            console.error('File parse error:', err);
            alert('Failed to read file. Please check the format.');
        }
    }

    function openMappingModal() {
        if (!importFile) { alert('Please select a file first.'); return; }
        if (!importHeaders.length) { alert('No columns found in file.'); return; }
        setMappingOpen(true);
    }

    // ── IMPORT: confirm mapping & bulk upload ─────────────────────────────────
    async function confirmImport() {
        if (!mapPhone) { alert('Mobile Number column is required.'); return; }

        setImporting(true);
        const user_id = localStorage.getItem('user_id') || 1;
        let success = 0, failed = 0;

        const phoneIdx = importHeaders.indexOf(mapPhone);
        const nameIdx  = mapName         ? importHeaders.indexOf(mapName)         : -1;
        const emailIdx = mapEmail        ? importHeaders.indexOf(mapEmail)        : -1;
        const ccIdx    = mapCountryCode  ? importHeaders.indexOf(mapCountryCode)  : -1;

        // Process in batches of 50
        const batchSize = 50;
        for (let i = 0; i < importRows.length; i += batchSize) {
            const batch = importRows.slice(i, i + batchSize);
            const contact_ids = [];

            for (const row of batch) {
                const phone = row[phoneIdx]?.trim();
                if (!phone) { failed++; continue; }
                try {
                    const cr = await fetch(`${API_URL}/auth/contacts`, {
                        method: 'POST', headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            user_id,
                            phone,
                            name:         nameIdx  >= 0 ? row[nameIdx]?.trim()  || null : null,
                            email:        emailIdx >= 0 ? row[emailIdx]?.trim() || null : null,
                            country_code: ccIdx    >= 0 ? row[ccIdx]?.trim()   || defaultCC : defaultCC,
                        }),
                    });
                    if (!cr.ok) { failed++; continue; }
                    const { contact_id } = await cr.json();
                    if (contact_id) contact_ids.push(contact_id);
                    else failed++;
                } catch { failed++; }
            }

            // Bulk link batch to group
            if (contact_ids.length) {
                try {
                    await fetch(`${API_URL}/auth/groups/${groupId}/contacts`, {
                        method: 'POST', headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ contact_ids }),
                    });
                    success += contact_ids.length;
                } catch { failed += contact_ids.length; }
            }
        }

        setImporting(false);
        setMappingOpen(false);
        setImportResult({ success, failed });
        await fetchContacts();
    }

    // ── render ────────────────────────────────────────────────────────────────
    return (
        <>
            <div className='dark:bg-[#121519] bg-[#fff] min-h-screen w-[100%] px-4'>

                {/* Header */}
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 flex justify-between items-start'>
                    <div>
                        <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>
                            Manage Contacts
                            {group && <span className='ml-2 text-[14px] font-normal text-[#316bb0]'>— {group.group_name}</span>}
                        </h1>
                        <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center'>
                            <span>Home</span><IoIosArrowForward />
                            <span onClick={() => navigate('/groups')} className='hover:text-[#316bb0] cursor-pointer'>Group List</span>
                            <IoIosArrowForward /><span>Manage Contacts</span>
                        </div>
                    </div>
                    <div className='flex gap-2 mt-1'>
                        <button onClick={exportCsv}
                            className='hover:bg-[#37715d] border-[1px] border-[#37715d] flex items-center text-[11px] hover:text-[#fff] text-[#37715d] font-bold p-2 gap-1 rounded-[5px]'>
                            ⬇️ Export CSV
                        </button>
                        <button onClick={() => navigate('/Client/Groups/Index')}
                            className='hover:bg-[#576071] border-[1px] border-[#576071] flex items-center text-[11px] hover:text-[#fff] text-[#576071] font-bold p-2 gap-1 rounded-[5px]'>
                            ← Back to Groups
                        </button>
                    </div>
                </div>

                {/* Action buttons */}
                <div className='flex gap-2 mt-4'>
                    <button onClick={openCreateModal}
                        className='hover:bg-[#316bb0] border-[1px] border-[#316bb0] flex items-center text-[11px] hover:text-[#fff] text-[#316bb0] font-bold p-2 gap-1 rounded-[5px]'>
                        <MdOutlineAdd className='text-[14px]' /> Add Contact
                    </button>
                    <button onClick={openImportModal}
                        className='hover:bg-[#7c3aed] border-[1px] border-[#7c3aed] flex items-center text-[11px] hover:text-[#fff] text-[#7c3aed] font-bold p-2 gap-1 rounded-[5px]'>
                        ⬆️ Import Contacts
                    </button>
                </div>

                {/* Filter bar */}
                <div className='w-[100%] flex justify-between px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4 cursor-pointer'
                    onClick={() => setShowFilter(v => !v)}>
                    <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff]'>Filter Records</div>
                    <span className='text-[#576071] dark:text-[#fff]'>{showFilter ? '▼' : '▲'}</span>
                </div>

                {showFilter && (
                    <div className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519]' onClick={e => e.stopPropagation()}>
                        <div className='w-[100%] flex flex-wrap gap-4'>
                            {[
                                { label: 'Phone Number', value: filterPhone, set: setFilterPhone, type: 'text',  ph: 'Search phone...' },
                                { label: 'Name',         value: filterName,  set: setFilterName,  type: 'text',  ph: 'Search name...' },
                                { label: 'Email',        value: filterEmail, set: setFilterEmail, type: 'email', ph: 'Search email...' },
                            ].map(f => (
                                <div key={f.label} className='w-full sm:w-[30%] flex flex-col gap-1'>
                                    <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>{f.label}</label>
                                    <input value={f.value} onChange={e => f.set(e.target.value)}
                                        onKeyDown={e => e.key === 'Enter' && applyFilter()}
                                        className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                        type={f.type} placeholder={f.ph} />
                                </div>
                            ))}
                            <div className='flex items-center gap-1 mt-4'>
                                <button onClick={applyFilter} className='flex items-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff]'>
                                    <FaFilter /><span className='text-[12px] font-bold'>Filter</span>
                                </button>
                                <button onClick={clearFilter} className='flex items-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff]'>
                                    <TbReload /><span className='text-[12px] font-bold'>Clear</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Table */}
                <table className="w-full overflow-hidden border-[1px] border-[#dee2e6]">
                    <thead>
                        <tr>
                            {['#', 'Phone Number', 'Name', 'Email', 'Country Code', 'Actions'].map((h, i) => (
                                <th key={h} className="p-2 border-[1px] border-[#dee2e6] text-left">
                                    <div className="flex justify-between items-center gap-2">
                                        <span className='text-[11px] text-[#576071] dark:text-[#fff]'>{h}</span>
                                        {i > 0 && i < 5 && <button type="button" className="text-gray-400 hover:text-black"><TbArrowsSort /></button>}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan={6} className="p-4 text-center text-[12px] text-gray-400">Loading...</td></tr>
                        ) : filtered.length === 0 ? (
                            <tr className="bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan={6} className="p-3 text-center text-[11px] text-gray-500">No contacts found</td>
                            </tr>
                        ) : filtered.map((c, idx) => (
                            <tr key={c.id} className="text-[12px] border-b hover:bg-[#f7fafc] dark:hover:bg-[#1a1f26]">
                                <td className="p-2 text-gray-400">{idx + 1}</td>
                                <td className="p-2 font-medium">
                                    {c.country_code && <span className='text-gray-400 mr-1'>{c.country_code}</span>}
                                    {c.phone}
                                </td>
                                <td className="p-2">{c.name  || <span className='text-gray-300'>—</span>}</td>
                                <td className="p-2">{c.email || <span className='text-gray-300'>—</span>}</td>
                                <td className="p-2">
                                    {c.country_code
                                        ? <span className='bg-[#ebf4ff] text-[#316bb0] rounded px-2 py-0.5 text-[10px] font-bold'>{c.country_code}</span>
                                        : <span className='text-gray-300'>—</span>}
                                </td>
                                <td className="p-2">
                                    <div className='flex gap-2'>
                                        <button onClick={() => openEditModal(c)} title="Edit"
                                            className="border px-2 py-1 rounded text-blue-500 hover:bg-blue-50 text-[13px]">✏️</button>
                                        <button onClick={() => deleteContact(c.id)} title="Remove"
                                            className="border px-2 py-1 rounded text-red-500 hover:bg-red-50 text-[13px]">🗑️</button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p className='text-[11px] text-[#3f7fc8] mt-2'>
                    Showing 1 to {filtered.length} of {contacts.length} records
                </p>
            </div>

            {/* ── Add / Edit Contact Modal ── */}
            <Addgroup isOpen={modalOpen} onClose={closeModal} heading={editingContact ? 'Edit Contact' : 'Add Contact'}>
                <div className='py-2 border-y-[1px] border-[#8b8a8a67] my-2 w-[100%]'>
                    <div className='flex flex-col gap-3'>
                        <div className='flex gap-2'>
                            <div className='flex flex-col gap-1' style={{ minWidth: '140px' }}>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Country Code <span className='text-red-500'>*</span></label>
                                <select value={form.country_code} onChange={e => handleChange('country_code', e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'>
                                    {COUNTRY_CODES.map(c => <option key={c.code} value={c.code}>{c.label}</option>)}
                                </select>
                            </div>
                            <div className='flex flex-col gap-1 flex-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Phone Number <span className='text-red-500'>*</span></label>
                                <input value={form.phone} onChange={e => handleChange('phone', e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="tel" placeholder='Enter mobile number' />
                                <span className='text-[10px] text-gray-400'>Required for WABA messaging</span>
                            </div>
                        </div>
                        <div className='flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Name <span className='text-gray-400 font-normal'>(optional)</span></label>
                            <input value={form.name} onChange={e => handleChange('name', e.target.value)}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                type="text" placeholder='Contact name' />
                        </div>
                        <div className='flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Email <span className='text-gray-400 font-normal'>(optional)</span></label>
                            <input value={form.email} onChange={e => handleChange('email', e.target.value)}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                type="email" placeholder='email@example.com' />
                        </div>
                    </div>
                </div>
                <div className='w-[100%] flex justify-end gap-1'>
                    <button onClick={saveContact} disabled={saving}
                        className='p-2 bg-[#00816a] rounded-md text-[12px] font-semibold text-[#fff] disabled:opacity-60'>
                        {saving ? 'Saving...' : 'Save'}
                    </button>
                    <button onClick={closeModal} className='p-2 bg-[#d3dde6] rounded-md text-[12px] font-semibold text-[#555555]'>Close</button>
                </div>
            </Addgroup>

            {/* ── Import Modal ── */}
            {importModalOpen && (
                <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-30">
                    <div className="bg-white dark:bg-[#121519] p-5 rounded-lg shadow-lg relative w-[520px] max-w-[95vw]">
                        {/* Header */}
                        <div className='flex justify-between items-center mb-3'>
                            <span className='text-[#121519] font-semibold text-[18px] dark:text-[#fff]'>Import Contacts</span>
                            <button onClick={() => setImportModalOpen(false)} className="text-[#858484] text-[18px]">✕</button>
                        </div>

                        <div className='border-y-[1px] border-[#8b8a8a67] py-3 flex flex-col gap-3'>

                            {/* Info alert */}
                            <div className='bg-[#ebf8ff] border border-[#90cdf4] rounded-md px-3 py-2 text-[11px] text-[#2b6cb0] flex gap-2'>
                                <span>ℹ️</span>
                                <div>
                                    <strong>Supported formats:</strong> .csv, .xlsx, .xls, .txt
                                    <br />Mobile Number column is <strong>required</strong>. Name and Email are optional.
                                </div>
                            </div>

                            {/* File input */}
                            <div className='flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Upload File <span className='text-red-500'>*</span></label>
                                <div className='flex gap-2 items-center'>
                                    <input ref={fileInputRef} type="file"
                                        accept=".csv,.xlsx,.xls,.txt"
                                        onChange={handleFileChange}
                                        className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] px-2 py-1.5 outline-none dark:bg-[#121519] dark:text-[#fff] flex-1' />
                                </div>
                                <span className='text-[10px] text-red-400'>
                                    Supports only <strong>.csv, .xls, .xlsx, .txt</strong> files. &nbsp;
                                    <a href="#" className='text-[#3f7fc8] underline' onClick={e => {
                                        e.preventDefault();
                                        // Generate & download sample CSV
                                        const sample = 'phone,name,email,country_code\n9876543210,John Doe,john@example.com,+91\n8765432109,Jane Smith,,+91';
                                        const a = document.createElement('a');
                                        a.href = 'data:text/csv,' + encodeURIComponent(sample);
                                        a.download = 'sample_import.csv';
                                        a.click();
                                    }}>Download Sample File</a>
                                </span>
                            </div>

                            {/* Default country code (used when file has no CC column) */}
                            <div className='flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Default Country Code</label>
                                <select value={defaultCC} onChange={e => setDefaultCC(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[200px]'>
                                    {COUNTRY_CODES.map(c => <option key={c.code} value={c.code}>{c.label}</option>)}
                                </select>
                                <span className='text-[10px] text-gray-400'>Applied when file has no country code column</span>
                            </div>

                            {/* Preview: show row count */}
                            {importHeaders.length > 0 && (
                                <div className='bg-[#f0fff4] border border-[#9ae6b4] rounded-md px-3 py-2 text-[11px] text-[#276749]'>
                                    ✅ File parsed — <strong>{importRows.length}</strong> rows detected,
                                    &nbsp;<strong>{importHeaders.length}</strong> columns:&nbsp;
                                    <em>{importHeaders.join(', ')}</em>
                                </div>
                            )}

                            {/* Import result */}
                            {importResult && (
                                <div className={`rounded-md px-3 py-2 text-[11px] border ${importResult.failed === 0 ? 'bg-[#f0fff4] border-[#9ae6b4] text-[#276749]' : 'bg-[#fffaf0] border-[#f6ad55] text-[#744210]'}`}>
                                    Import complete — ✅ <strong>{importResult.success}</strong> imported
                                    {importResult.failed > 0 && <>, ❌ <strong>{importResult.failed}</strong> failed (blank/invalid phone)</>}
                                </div>
                            )}
                        </div>

                        <div className='flex justify-end gap-2 mt-3'>
                            <button onClick={openMappingModal} disabled={!importHeaders.length}
                                className='p-2 bg-[#7c3aed] rounded-md text-[12px] font-semibold text-[#fff] disabled:opacity-50 disabled:cursor-not-allowed'>
                                Next: Map Columns →
                            </button>
                            <button onClick={() => setImportModalOpen(false)}
                                className='p-2 bg-[#d3dde6] rounded-md text-[12px] font-semibold text-[#555555]'>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Column Mapping Modal ── */}
            {mappingOpen && (
                <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-40">
                    <div className="bg-white dark:bg-[#121519] p-5 rounded-lg shadow-xl w-[520px] max-w-[95vw]">
                        <div className='flex justify-between items-center mb-3'>
                            <span className='text-[#121519] font-semibold text-[18px] dark:text-[#fff]'>Map Columns to Fields</span>
                            <button onClick={() => setMappingOpen(false)} className="text-[#858484] text-[18px]">✕</button>
                        </div>

                        <div className='border-y-[1px] border-[#8b8a8a67] py-3 flex flex-col gap-3'>
                            {/* Info */}
                            <div className='bg-[#ebf8ff] border border-[#90cdf4] rounded-md px-3 py-2 text-[11px] text-[#2b6cb0]'>
                                ℹ️ Select which column from your file maps to each contact field.
                                <strong> Mobile Number</strong> is required.
                            </div>

                            {/* Preview table (first 3 rows) */}
                            {importRows.length > 0 && (
                                <div className='overflow-x-auto rounded border border-[#dee2e6]'>
                                    <table className='text-[10px] w-full'>
                                        <thead>
                                            <tr className='bg-[#f7fafc]'>
                                                {importHeaders.map(h => (
                                                    <th key={h} className='px-2 py-1 border-r border-[#dee2e6] text-[#576071] font-semibold text-left'>{h}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {importRows.slice(0, 3).map((row, i) => (
                                                <tr key={i} className='border-t border-[#dee2e6]'>
                                                    {importHeaders.map((_, ci) => (
                                                        <td key={ci} className='px-2 py-1 border-r border-[#dee2e6] text-[#2d3748]'>{row[ci] || ''}</td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className='text-[10px] text-gray-400 px-2 py-1'>Showing preview of first {Math.min(3, importRows.length)} rows</div>
                                </div>
                            )}

                            {/* Mapping selects */}
                            {[
                                { label: 'Mobile Number Column', required: true,  value: mapPhone,       set: setMapPhone },
                                { label: 'Name Column',          required: false, value: mapName,        set: setMapName },
                                { label: 'Email Column',         required: false, value: mapEmail,       set: setMapEmail },
                                { label: 'Country Code Column',  required: false, value: mapCountryCode, set: setMapCountryCode },
                            ].map(f => (
                                <div key={f.label} className='flex flex-col gap-1'>
                                    <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>
                                        {f.label}
                                        {f.required
                                            ? <span className='text-red-500'> *</span>
                                            : <span className='text-gray-400 font-normal'> (optional)</span>}
                                    </label>
                                    <select value={f.value} onChange={e => f.set(e.target.value)}
                                        className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'>
                                        <option value=''>-- Select Column --</option>
                                        {importHeaders.map(h => <option key={h} value={h}>{h}</option>)}
                                    </select>
                                </div>
                            ))}
                        </div>

                        <div className='flex justify-end gap-2 mt-3'>
                            <button onClick={confirmImport} disabled={importing || !mapPhone}
                                className='p-2 bg-[#00816a] rounded-md text-[12px] font-semibold text-[#fff] disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1'>
                                {importing
                                    ? <><span className='animate-spin'>⟳</span> Importing...</>
                                    : <>✔ Confirm & Import ({importRows.length} rows)</>}
                            </button>
                            <button onClick={() => setMappingOpen(false)}
                                className='p-2 bg-[#d3dde6] rounded-md text-[12px] font-semibold text-[#555555]'>
                                Back
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ManageContacts;
